import { render } from "./OnlineCarePX.vue?vue&type=template&id=32fe7a93&scoped=true&ts=true"
import script from "./OnlineCarePX.vue?vue&type=script&lang=ts"
export * from "./OnlineCarePX.vue?vue&type=script&lang=ts"

import "./OnlineCarePX.vue?vue&type=style&index=0&id=32fe7a93&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32fe7a93"]])

export default __exports__